module.exports = __webpack_public_path__ + "static/media/android.4b8e17da.svg";